import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageJson from '../package.json';

const initializeSentry = () => {

  Sentry.init({
    dsn: "https://37565602b85daffa1d4cab54014de9c1@o4508598428368896.ingest.us.sentry.io/4508603924086784",
    release: "product-selector@" + packageJson.version,
    environment: environment.environmentName,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        colorScheme: "system",
      }),
      Sentry.captureConsoleIntegration(),
      Sentry.browserSessionIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^.*$/],
    // Profile Sample Rate
    profilesSampleRate: 1.0,
  });
}


if (environment.production) {
  enableProdMode();
  initializeSentry();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
